import React from "react";
import "./sectionTitleStyle.scss";

const SectionBlackLabel = ({ title }) => {
  return (
    <div>
      <label htmlFor={title} className="section-black-label mt-3">
        {title}
      </label>
    </div>
  );
};

export default SectionBlackLabel;
